import { useState } from 'react';
import AttendanceSheet from './AttendanceSheet';
import axios from 'axios';
import ReportGenerator from './ReportGenerate';

const AttendanceManager = () => {
  const [reportData, setReportData] = useState(null);
  const [detailedData, setDetailedData] = useState(null);
  const [dateRange, setDateRange] = useState({
    start: new Date(),
    end: new Date()
  });

  const generateReport = async (start, end) => {
    try {
      const { data } = await axios.get('https://api.pranucollection.com/api/attendance/report', {
        params: {
          startDate: start.toISOString(),
          endDate: end.toISOString()
        }
      });
      setReportData(data.summary);
      setDetailedData(data.details);
      setDateRange({ start, end });
    } catch (error) {
      console.error('Error generating report:', error);
    }
  };

  return (
    <div className="space-y-8 p-4">
      <AttendanceSheet onUpdate={() => generateReport(dateRange.start, dateRange.end)} />
      <ReportGenerator
        reportData={reportData}
        detailedData={detailedData}
        generateReport={generateReport}
        startDate={dateRange.start}
        endDate={dateRange.end}
      />
    </div>
  );
};

export default AttendanceManager;